import { T as TempMap } from "../../../utils/temp-map-035b2408.mjs";
import { d as defineVuesticPlugin } from "../../vue-plugin/utils/define-vuestic-plugin-8c565dfe.mjs";
const VaAppCachePluginKey = Symbol("VaAppCachePlugin");
const CachePlugin = defineVuesticPlugin(() => ({
  install(app) {
    const cache = {
      colorContrast: {},
      bgTempCache: new TempMap()
    };
    app.provide(VaAppCachePluginKey, cache);
  }
}));
export {
  CachePlugin as C,
  VaAppCachePluginKey as V
};
//# sourceMappingURL=index-d7f76192.mjs.map
